import { render, staticRenderFns } from "./LeftPanel.vue?vue&type=template&id=3a67b764&scoped=true&"
import script from "./LeftPanel.vue?vue&type=script&lang=js&"
export * from "./LeftPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a67b764",
  null
  
)

export default component.exports